<template>
	<NP-Modal :class="{ 'pos-modal': true, [local_state]: true }" :toggle="toggle" :label="label">
		<section v-if="local_state === localStates.pos_details">
			<div class="info-block">
				<span class="title">№ POS-терміналу</span>
				<span class="text">{{ posDetails.code }}</span>
			</div>
			<div class="info-block">
				<span class="title">Банк</span>
				<span class="text">{{ posMerchantBank }}</span>
			</div>
			<div class="info-block">
				<span class="title">Мерчанти</span>
				<span class="text">{{ posMerchantTypes }}</span>
			</div>
			<div class="buttons">
				<NP-Button
					type="submit"
					priority="medium"
					@click="() => getLastReceipt({ loadingAction: true })"
					:loading="loadingActions.includes('getLastReceipt')"
				>
					Переглянути останній чек
				</NP-Button>
				<NP-Button
					priority="high"
					@click="() => getPosTransactions(query)"
					:loading="loadingActions.includes('getPosTransactions')"
				>
					Список операцій
				</NP-Button>
			</div>
		</section>

		<section v-if="local_state === localStates.last_receipt_details">
			<div class="info-block black">
				<span class="title">№ POS-терміналу</span>
				<span class="text">{{ posDetails.code }}</span>
			</div>
			<div class="container">
				<div class="info-block">
					<span class="title">Сума</span>
					<span class="text">{{ lastReceiptDetails.amount | formatMoney }}<span class="uah" /></span>
				</div>
				<div class="info-block">
					<span class="title">Дата</span>
					<span class="text">{{ lastReceiptDetails.date || '-' }}</span>
				</div>
			</div>
			<div class="container">
				<div class="info-block">
					<span class="title">Клієнт</span>
					<span class="text">{{ lastReceiptDetails.issuer || '-' }}</span>
				</div>
				<div class="info-block">
					<span class="title">Карта</span>
					<span class="text">{{ lastReceiptDetails.pan || '-' }}</span>
				</div>
			</div>
			<div class="info-block">
				<span class="title">Еквайр</span>
				<span class="text">{{ lastReceiptDetails.card_merchant_bank }}</span>
			</div>
			<div class="container">
				<div class="info-block">
					<span class="title">Термінал №</span>
					<span class="text">{{ lastReceiptDetails.terminal_id || '-' }}</span>
				</div>
				<div class="info-block">
					<span class="title">Код авторизації</span>
					<span class="text">{{ lastReceiptDetails.auth_code || '-' }}</span>
				</div>
			</div>
			<div class="container">
				<div class="info-block">
					<span class="title">Чек</span>
					<span class="text">{{ lastReceiptDetails.invoice_num || '-' }}</span>
				</div>
				<div class="info-block">
					<span class="title">RRN</span>
					<span class="text">{{ lastReceiptDetails.rrn || '-' }}</span>
				</div>
			</div>
		</section>

		<section v-if="local_state === localStates.transactions_details">
			<div class="container">
				<div class="info-block black">
					<span class="title">№ POS-терміналу</span>
					<span class="text">{{ posDetails.code }}</span>
				</div>
				<div class="info-block black">
					<span class="title">Банк</span>
					<span class="text">{{ posMerchantBank }}</span>
				</div>
			</div>
			<div class="container">
				<div class="info-block">
					<span class="title">Дебет</span>
					<span class="text">{{ posDetails.last_known_debit_balance | formatMoney }}<span class="uah" /></span>
				</div>
				<div class="info-block">
					<span class="title">Кредит</span>
					<span class="text">{{ posDetails.last_known_credit_balance | formatMoney }}<span class="uah" /></span>
				</div>
				<div class="info-block">
					<span class="title">Відхилено</span>
					<span class="text">{{ posDetails.last_known_cancelled_balance | formatMoney }}<span class="uah" /></span>
				</div>
			</div>
			<NP-Table
				class="transactions-details-table"
				:data="posTransactionsDetails.transactions || []"
				:external-local-query="query"
				:columns="columns"
				:options="options"
				:apply="apply"
				:loading="table_loading"
			/>
		</section>
	</NP-Modal>
</template>

<script>
import BigNumber from 'bignumber.js';
import { DateTime } from 'luxon';

import { locale as posMerchantTypesLocal } from '@repo/enums/pos-merchant-types';
import { locale as posMerchantBanksLocal } from '@repo/enums/pos-merchant-banks';

let localStates = {
	pos_details: 'pos_details',
	transactions_details: 'transactions_details',
	last_receipt_details: 'last_receipt_details'
};

export default {
	name: 'POSDetailsModal',
	props: {
		toggle: { type: Function, default: null },
		getLastReceipt: { type: Function, default: null },
		getPosTransactions: { type: Function, default: null },
		lastReceiptDetails: { type: Object, default: () => ({}) },
		posTransactionsDetails: { type: Object, default: () => ({}) },
		posDetails: { type: Object, default: () => ({}) },
		loadingActions: { type: Array, default: () => [] }
	},
	data() {
		return {
			localStates,
			table_loading: false,
			local_state: localStates.pos_details,
			query: { limit: 5, offset: 0 }
		};
	},
	computed: {
		label() {
			switch (this.local_state) {
				case localStates.transactions_details:
					return 'Список операцій POS-терміналу';
				case localStates.last_receipt_details:
					return 'Останній сліп чек терміналу';
				default:
					return 'Деталі POS-терміналу';
			}
		},
		posMerchantBank() {
			return posMerchantBanksLocal[this.posDetails?.merchant_bank] || '-';
		},
		posMerchantTypes() {
			return (
				(this.posDetails?.merchants?.length &&
					this.posDetails.merchants.map((m) => posMerchantTypesLocal[m.type]).join(', ')) ||
				'-'
			);
		},
		columns() {
			return [
				{
					key: 'date',
					label: 'Дата',
					format: (val) => (val ? DateTime.fromFormat(val, 'yyMMddHHmmss').toFormat('dd/MM/yyyy HH:mm:ss') : '-')
				},
				{
					key: 'rrn',
					label: 'RRN'
				},
				{
					key: 'auth_code',
					label: 'Код авторизації'
				},
				{
					key: 'trn_status',
					label: 'Статус',
					class: (row) =>
						[2, 4].includes(row.trn_status) ||
						(row.trn_status === 1 &&
							row.auth_code &&
							(row.auth_code.toLowerCase().includes('decl') || row.auth_code.toLowerCase().includes('cancel')))
							? 'red'
							: '',
					format: (val, row) => {
						switch (val) {
							case 0:
							case 1:
								return row.auth_code &&
									!(row.auth_code.toLowerCase().includes('decl') || row.auth_code.toLowerCase().includes('cancel'))
									? 'Успiшна'
									: 'Вiдхилена';
							case 2:
								return 'Вiдхилена';
							case 3:
							case 21:
								return 'Повернена';
							case 4:
								return 'Вiдмiнена';
							default:
								return 'Успiшна';
						}
					}
				},
				{
					type: 'amount',
					key: 'amount',
					label: 'Сума',
					format: (val) => new BigNumber(val).div(100).toString()
				}
			];
		},
		options() {
			let { total } = this.posTransactionsDetails;
			return {
				pagination: {
					total,
					totalText: `Всього операцій POS: ${total}`
				}
			};
		}
	},
	methods: {
		apply(q) {
			this.table_loading = true;
			this.getPosTransactions({ limit: q.limit, offset: q.offset });
		}
	},
	watch: {
		lastReceiptDetails() {
			this.local_state = localStates.last_receipt_details;
		},
		posTransactionsDetails(v) {
			this.table_loading = false;
			this.local_state = localStates.transactions_details;
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/variables';
@import '@assets/scss/mixins';

.info-block {
	display: flex;
	flex-direction: column;
	width: 100%;
	min-height: 55px;
	padding: 12px;
	border-radius: $border-radius;
	background: $gray-10;
	margin-bottom: 10px;
	&.black {
		background: $gray-50;
		.title {
			color: $gray-10;
		}
		.text {
			color: $white;
		}
	}
}
.title {
	font-family: Proxima Nova Semibold;
	color: $gray-40;
	font-size: 12px;
	line-height: 15px;
}
.text {
	color: $gray-50;
	font-size: 14px;
	line-height: 17px;
	.uah {
		margin-left: 4px;
	}
}

.pos-modal.pos_details {
	::v-deep .modal-container {
		width: 437px;
	}
	.buttons {
		width: 100%;
		margin-top: 24px;
		display: flex;
		justify-content: space-between;
		::v-deep .button:not(:last-child) {
			margin-right: 12px;
		}
	}
}

.pos-modal.last_receipt_details {
	::v-deep .modal-container {
		height: 510px;
		width: 414px;
	}
	.container {
		display: flex;
		.info-block:not(:last-child) {
			margin-right: 12px;
		}
	}
}

.pos-modal.transactions_details {
	::v-deep .modal-container {
		height: 615px;
		width: 613px;
		position: relative;
	}
	.container {
		display: flex;
		.info-block:not(:last-child) {
			margin-right: 12px;
		}
	}
	.transactions-details-table {
		::v-deep .controls-container {
			display: none;
		}
		::v-deep .table table {
			th {
				padding-bottom: 4px;
			}
			tbody tr {
				.cell {
					padding: 9px 10px;
				}
				.cell.red {
					color: $red;
				}
			}
		}
		::v-deep .pagination {
			position: absolute;
			box-shadow: none;
			.first {
				display: none;
			}
			.masked-select-wrap {
				display: none;
			}
		}
	}
}
</style>
